import {
  TextField,
  Button,
  Typography,
  Box,
  Divider,
  Stack,
} from "@mui/material";
import { PhoneOutlined as PhoneIcon } from "@mui/icons-material";
import PhoneConnectInput from "./PhoneConnectInput";
import CountrySelectDrawer from "./CountrySelectDrawer";

interface PhoneLoginFormProps {
  phoneNumber: string;
  onPhoneNumberChange: (value: string) => void;
  onSubmit: () => void;
  onBackToLogin: () => void;
  isSubmitting: boolean;
  error?: string;
}

export const PhoneLoginForm = ({
  phoneNumber,
  onPhoneNumberChange,
  onSubmit,
  onBackToLogin,
  isSubmitting,
  error,
}: PhoneLoginFormProps) => {
  return (
    <Box>
      {/* <TextField
        label="Phone Number"
        value={phoneNumber}
        onChange={(e) => onPhoneNumberChange(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
        inputProps={{
          inputMode: "tel",
        }}
      /> */}
      <PhoneConnectInput />

      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={isSubmitting || !phoneNumber}
        fullWidth
        sx={{ mb: 2 }}
      >
        {isSubmitting ? "Sending SMS..." : "Send SMS"}
      </Button>

      {error && <Typography color="error">{error}</Typography>}

      <Divider sx={{ my: 2 }}></Divider>

      <Button
        variant="outlined"
        onClick={onBackToLogin}
        sx={{ mb: 2 }}
        fullWidth
      >
        Back to Email Login
      </Button>
      <CountrySelectDrawer />
    </Box>
  );
};
